import { isNotDefined } from '@sgme/fp';
import { ISalesCounterpart } from 'models/ISalesCounterpart';
import { getFormEnrichedData, getFormEnrichedUnderlying } from 'state/selectors';
import type { AppState } from 'state/state.model';
import { WorkspaceType } from 'state/workspaces/model';

import { buildUnderlyingsDatesCompositeKey } from './underlyingsDates.utils';
import type { UnderlyingsDatesKey } from './underlyingsDatesState.model';
import { UnderlyingsDatesPayload } from './underlyingsDatesState.model';

export function getUnderlyingsDatesByKey(state: AppState, underlyingsDatesKey?: UnderlyingsDatesKey) {
  if (underlyingsDatesKey) {
    const value = state.underlyingsDates[buildUnderlyingsDatesCompositeKey(underlyingsDatesKey)];
    return value;
  }
}

export function buildUnderlyingsDatesPayload(state: AppState, tabId: string, workspace: WorkspaceType) {
  const underlyingsDatesPayload = getPayload(state, tabId);
  if (underlyingsDatesPayload) {
    if (workspace === 'dynamic') {
      return {
        ...underlyingsDatesPayload,
        instrumentName: underlyingsDatesPayload.productType,
        instrumentContractName: underlyingsDatesPayload.productSubType,
        productType: '',
        productSubType: '',
      } as UnderlyingsDatesPayload;
    }
    return underlyingsDatesPayload as UnderlyingsDatesPayload;
  }
  return undefined;
}

function getPayload(state: AppState, tabId: string) {
  const underlying = getFormEnrichedUnderlying(state, tabId);
  if (isNotDefined(underlying?.id) || underlying?.id === '') {
    return undefined;
  }

  const enrichedData = getFormEnrichedData(state, tabId);
  const selectedOnBehalfClient = enrichedData.SelectedOnBehalfClient as ISalesCounterpart;
  const onBehalfClient = {
    bdrLegalId: selectedOnBehalfClient?.id ?? '',
    bdrName: selectedOnBehalfClient?.label ?? '',
    eliot: selectedOnBehalfClient?.eliotCode ?? '',
    countryResidenceCode: selectedOnBehalfClient?.countryResidenceCode ?? '',
  };
  const underliyngsDatesPayload = {
    productType: enrichedData.ProductType as string,
    productSubType: enrichedData.ProductSubtype as string,
    underlyingBloombergCode: underlying?.id,
    onBehalfClient,
  };
  return underliyngsDatesPayload;
}
export function getUnderlyingsDatesByTabId(state: AppState, tabId: string) {
  const key = getPayload(state, tabId);
  return getUnderlyingsDatesByKey(state, key);
}

export function isUnderlyingsDatesExists(state: AppState, underlyingsDatesKey?: UnderlyingsDatesKey) {
  if (underlyingsDatesKey) {
    return state.underlyingsDates[buildUnderlyingsDatesCompositeKey(underlyingsDatesKey)] !== undefined;
  }
  return false;
}
